
import KlookLangSelector from '../../desktop/lang-selector.vue'

export default {
  components: {
    KlookLangSelector
  }
}
